const isSecure = () => /^https/.test(document.location.protocol);
export {
  isSecure,
};
